import React, {
  Suspense,
  useMemo,
  useEffect,
  useState,
  lazy,
  createContext,
  useContext,
} from 'react';

import { LTLoader } from '@lambdatestincprivate/lt-components';

import { Provider } from 'react-redux';

import createMyStore from '../../redux/store';
import { initializeEnv } from '../../utils/env';
import './style.css';

const AutomationLogsPage = lazy(() => import('./AutomationLogsPageWrapper'));

const ComponentPageWrapper = lazy(() => import('./ComponentPageWrapper'));

const ComponentPages = ['playwright-trace', 'report-view'];
export const AutomationContext = createContext(null);

export default function App(props) {
  const env = props.env || {};
  const [isEnvReady, setIsEnvReady] = useState(false);

  // Initialize env registry and mark as ready when env is available
  useEffect(() => {
    // Initialize env (even if empty object) and mark as ready
    initializeEnv(env);
    setIsEnvReady(true);
  }, [env]);

  // Create store with env object only after env is ready
  const store = useMemo(() => {
    if (!isEnvReady) {
      return null;
    }
    return createMyStore(env);
  }, [env, isEnvReady]);

  if (!isEnvReady || !store) {
    return null;
  }

  return (
    <Provider store={store}>
      <AutomationContext.Provider
        value={{
          backToJobDetail: props?.backToJobDetail,
          fromHyperExecute: props?.fromHyperExecute,
          env: env,
          fromKane: props?.fromKane,
          backToKane: props?.backToKane,
          fromOtherProduct: props?.fromOtherProduct,
        }}
      >
        <Suspense fallback={<LTLoader />}>
          {
            // if we have to use a single component out of TestPageWeb
            // Then we can use this component wrapper to wrap the component so that store and env registration from here only
            // We can call it like this example: <TestPageWeb pageType="playwright-trace" />
            //pageType can be used to directly import that particular component out of TestPageWeb
            ComponentPages.includes(props.pageType) ? (
              <ComponentPageWrapper {...props} />
            ) : (
              <AutomationLogsPage {...props} />
            )}
        </Suspense>
      </AutomationContext.Provider>
    </Provider>
  );
}

export function useAutomationContext() {
  return useContext(AutomationContext);
}
